(() => {
  const setup = (scope) => {
    scope.querySelectorAll('[data-v2-header]').forEach((header) => {
      if (header.dataset.initialized) return;
      header.dataset.initialized = 'true';
      const menus = [...header.querySelectorAll('.v2-nav > details, .v2-mobile')];
      menus.forEach((menu) => menu.addEventListener('toggle', () => {
        if (menu.open) menus.filter((other) => other !== menu).forEach((other) => { other.open = false; });
      }));
      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const menu = event.target.closest('details[open]');
        if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
      });
      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) menus.forEach((menu) => { menu.open = false; });
      });
    });
    scope.querySelectorAll('[data-v2-library]').forEach((library) => {
      if (library.dataset.initialized) return;
      library.dataset.initialized = 'true';
      library.querySelectorAll('[data-filter]').forEach((button) => button.addEventListener('click', () => {
        library.querySelectorAll('[data-filter]').forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
        let count = 0;
        library.querySelectorAll('[data-category]').forEach((card) => {
          card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter;
          if (!card.hidden) count++;
        });
        library.querySelector('[data-filter-status]').textContent = count + (count === 1 ? ' design' : ' designs');
      }));
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
